"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Pagination = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var Pagination = _styledComponents["default"].nav.withConfig({
  displayName: "Paginationstyles__Pagination",
  componentId: "sc-s9v5d6-0"
})(["align-items:center;display:flex;text-align:center;"]);

exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.styles.js.map